import isEqual from "lodash/isEqual";
import pick from "lodash/pick";
import { Context, useContext } from "react";
import { StoreApi } from "zustand/index";
import { useStoreWithEqualityFn } from "zustand/traditional";

export const useStoreSelect = <StoreType, PropertiesType extends keyof StoreType>(
  storeContext: Context<StoreApi<StoreType>>,
  properties: readonly PropertiesType[]
): Pick<StoreType, PropertiesType> => {
  const store = useContext(storeContext);

  return useStoreWithEqualityFn(store, (state) => pick(state, properties), isEqual);
};
